import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({'font-size':''+_vm.valorFont+'px'}),attrs:{"id":"app"}},[_c(VApp,[_c(VMain,{attrs:{"fluid":""}},[_c('header-app',{on:{"accionAcce":_vm.accionBoton}}),(_vm.$route.path == '/')?_c('slider-app'):_vm._e(),_c('navUser',{attrs:{"cambiarPosicion":_vm.posnav,"id":"navusercont"}}),_c('transition',[_c('router-view',{key:_vm.$store.state.idContenido,staticClass:"cont-general"})],1),_c('footer-app',{staticClass:"cont-footer"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }